import React, {Component} from "react";
import "./Restore.css"
import Authentication from "../../authentication/Authentication";
import Api from "../../api/Api";
import {toast} from "react-toastify";

export default class Restore extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showRestoreButton: false,
            checked: "",
            bucketInfo: {},
            showLoading: false,
            showRestoreMessage: false,
            selectedTab: ""
        };

        this.authentication = new Authentication();
    };

    formatDate = (date) => {
        return date.split("+")[0]
    }

    handleCheckboxClick = (e, backup) => {
        if (this.formatDate(backup["LastModified"]) === this.state.checked) {
            this.setState({
                checked: "",
                bucketInfo: {}
            })
        } else {
            this.setState({
                checked: this.formatDate(backup["LastModified"]),
                bucketInfo: backup
            })
        }
    }

    handleRestore = (bucketInfo) => {
        const api = new Api();

        this.setState({
            checked: "",
            bucketInfo: {},
            showLoading: true,
            showRestoreMessage: true
        })

        if (this.authentication.isAdmin()) {
            api.pisaasRestore(() => console.log("Successful restore"), function (err) {
                console.log(err);
                toast.error("Failed to fetch Pisaas Instances", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }, this.props.domain, bucketInfo['VersionId'], this.props.pisaasInstanceId, this.props.packageId, this.props.region);
        }

    }
    render() {
        return (
            <>
                <div>
                    <h2 className={"config-header"} data-testid="config.header.restore">Restore</h2>
                    <ul>
                        <li>Pisaas instances are backed up every 6 hours and are stored for 30 days</li>
                        <li>Select which version you would like to restore</li>
                        <li>The restore process will take about 10 minutes</li>
                        <li>Your instance will not be available during this time</li>
                    </ul>
                    <div>
                        <p className={"field-name"}>Backups: </p>
                        <ul>
                            {this.props.backups.map((backup, index) => {
                                if (backup.tags.length === 0) {
                                    return (
                                        <div className={"backup-row"} data-testid="config.restore.backup.row" key={index}>
                                            <input onChange={(e) => this.handleCheckboxClick(e, backup['backup'])}
                                                   checked={this.state.checked === this.formatDate(backup['backup']["LastModified"])}
                                                   type={"checkbox"} className={"checkbox"} data-testid="config.restore.checkbox"/>
                                            <p data-testid="config.restore.backupDate" className={"backup-date"}>{this.formatDate(backup['backup']["LastModified"])}</p>
                                        </div>
                                    )
                                } else {
                                    return (
                                        <></>
                                    )
                                }
                            })}
                        </ul>
                        {this.state.checked ? <button data-testid="config.restore.button.restore" onClick={(e) => this.handleRestore(this.state.bucketInfo)}
                                                      className={"try-pi-btn btn-create"}>RESTORE</button> : this.state.showLoading ?
                            <i className="fa fa-spinner fa-pulse fa-3x fa-fw loading restore-loading"/> : <></>}
                        {this.state.showRestoreMessage ?
                            <p data-testid="config.restore.message">The restore process has begun. Please allow 10 minutes for this to complete</p> : <></>}
                    </div>
                </div>
            </>
        )
    }
}



